"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.xlIcons = exports.icons = void 0;
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const Spinner_1 = __importDefault(require("../Spinner/Spinner"));
exports.icons = [
    'cross',
    'cross_grey',
    'cross_white',
    'cross_purple',
    'search',
    'search_grey',
    'plus',
    'plus_grey',
    'minus',
    'check',
    'check_green_nocircle',
    'check_turquoise',
    'burgermenu',
    'burgermenu_hover',
    'delete',
    'user',
    'user_purple',
    'piechart',
    'arrow_right',
    'arrow_left',
    'arrow_up',
    'arrow_down',
    'calendar',
    'calendar_gray',
    'clock',
    'download',
    'arrow',
    'columns',
    'comment',
    'comment_solid_blue',
    'star',
    'alert_menu_icon',
    'menu_arrow_left',
    'menu_arrow_right',
    'edit',
    'edit_purple',
    'edit_blue',
    'phone',
    'snoozed_notification',
    'notification_bell_purple',
    'incident_assigned',
    'credit_card',
    'payment',
    'endusers_category',
    'tenants_category',
    'landlords_category',
    'vehicles_category',
    'vehicles_category_blue',
    'vehicles_category_gray',
    'vehicles_category_green',
    'sale_category',
    'invoice_category',
    'parkings_category',
    'other_category',
    'expand',
    'collapse',
    'download_circle',
    'pay_for_parking',
    'arrow_up_turquoise',
    'arrow_right_turquoise',
    'arrow_down_turquoise',
    'arrow_left_turquoise',
    'arrow_up_white',
    'arrow_up_gray',
    'arrow_up_light_gray',
    'arrow_right_white',
    'arrow_down_white',
    'arrow_down_gray',
    'arrow_down_light_gray',
    'arrow_left_white',
    'arrow_up_blue_dark',
    'arrow_down_blue_dark',
    'arrow_left_blue_dark',
    'arrow_right_blue_dark',
    'lane_arrow_right',
    'lane_arrow_left',
    'lane_arrow_left_and_right',
    'server',
    'save_floppy',
    'maintenance_gray',
    'maintenance_orange',
    'archived_gray',
    'manual_correction',
    'gear_gray',
    'payment_machine_blue',
    'payment_machine_white',
    'payment_machine_turquoise',
    'payment_machine_gray',
    'ev_charger_blue',
    'ev_charger_blue_filled',
    'ev_charger_white',
    'ev_charger_turquoise',
    'ev_charger_gray',
    'ev_vehicle_blue',
    'ev_vehicle_white',
    'ev_vehicle_turquoise',
    'ev_vehicle_gray',
    'ev_happy_vehicle_blue',
    'ev_happy_vehicle_white',
    'ev_happy_vehicle_turquoise',
    'ev_happy_vehicle_gray',
    'lightning_blue',
    'lightning_white',
    'lightning_turquoise',
    'lightning_gray',
    'copy_to_clipboard_blue',
    'copy_to_clipboard_white',
    'copy_to_clipboard_turquoise',
    'copy_to_clipboard_gray',
    'handicap_parking',
    'handicap_parking_blue',
    'wide_parking_spots',
    'refresh_blue',
    'refresh_gray',
    'refresh_turquoise',
    'refresh_white',
    'parkings_blue',
    'parkings_white',
    'parkings_turquoise',
    'parkings_gray',
    'picture_blue',
    'trash_can_blue',
    'trash_can_gray',
    'trash_can_turquoise',
    'trash_can_purple',
    'save_blue',
    'save_gray',
    'save_purple',
    'save_turquoise',
    'clock_blue',
    'facility',
    'rules_hammer',
    'cloud',
    'cloud_blue',
    'actions_purple_horizontal',
    'filter_blue',
    'eye_blue',
    'actions_white',
    'filter_white',
    'table_column_blue',
    'zone_blue',
    'drag_and_drop',
    'open_in_new_blue',
];
exports.xlIcons = [
    'excl_yellow',
    'info_blue',
    'excl_red',
    'excl_orange',
    'cross_red',
    'check_green',
    'check_blue',
    'info_grey',
    'tooltip',
    'facility_blue',
    'landlord_blue',
    'tenant_blue',
    'price_tag_blue',
    'clock_orange',
    'clock_purple',
    'blocked',
    'spinner',
];
const Icon = ({ icon, className, onClick, ariaHidden, size }) => {
    const readonlyIcons = exports.icons;
    const readonlyXlIcons = exports.xlIcons;
    const iconClasses = classnames_1.default({
        'aio-icon': readonlyIcons.includes(icon),
        'aio-icon-xl': readonlyXlIcons.includes(icon),
        'icon-clickable': !!onClick,
        [`aio-icon-${icon}`]: !!icon,
        [className]: !!className,
    });
    const iconHeight = typeof size === 'object' ? size.height : size;
    const iconWidth = typeof size === 'object' ? size.width : size;
    return (React.createElement("div", { onClick: onClick, className: iconClasses, "aria-hidden": ariaHidden, style: {
            height: iconHeight,
            width: iconWidth,
        } }, icon === 'spinner' ? React.createElement(Spinner_1.default, { size: "sm", color: "white", delay: "none" }) : React.createElement(React.Fragment, null, "\u00A0")));
};
exports.default = Icon;
//# sourceMappingURL=Icon.js.map